import { DatasourceInstructionMode } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export type DatasourceImportReportCategory =
  | 'created'
  | 'skippedSelected'
  | 'skippedExcluded'
  | 'selectedUpdated'
  | 'excludedUpdated';

export type DatasourceImportReport = {
  dealId: string;
  datasourceId: string;
  instructionMode: DatasourceInstructionMode;
  itemsCreatedIds: string[];
  selectedItemsUpdatedIds: string[];
  excludedItemsUpdatedIds: string[];
  itemsSkippedIds: string[];
  /** Supprimés par la synchronisation (SYNC_WITH_DEAL_ITEM_ID), vide sinon. */
  itemsDeletedIds: string[];
} | null;

export const datasourceImportReportState = atom<DatasourceImportReport>(null);
